import { withCurrentUser } from 'modules/auth/containers';
import { AuthLayout } from '../components';

export default withCurrentUser(AuthLayout);



// WEBPACK FOOTER //
// ./src/modules/layout/containers/AuthLayout.js